import React, { useState } from "react";
import {
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import Calendar from "assets/icon/calendar-pms.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Field, Formik } from "formik";
import ReactInputMask from "react-input-mask";

const AddLabvalues = ({ labValues, setLabValues }) => {
  const [startDate, setStartdate] = useState("");
  const [error, setError] = useState(false);
  const [focusedInput, setFocusedInput] = useState("");

  let hasDatePopupOpen = false;
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setStartdate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setStartdate(null);
      // SearchTerms.startDate=null
    }
  };
  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && startDate !== null) {
      setStartdate(null);
      setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLabValues({ ...labValues, [name]: value });
  };

  return (
    <div style={{ width: "50vw", paddingLeft: "20px", paddingRight: "12px" }}>
      <Row className="mb-2">
        <Col sm={6} md={6} lg={6} className="required-date">
          <Label className="add-clinic">
            <span className="text-danger">*</span> Record Date
          </Label>
          <InputGroup onMouseLeave={handleMouseLeave} className="date-14px">
            <DatePicker
              id="startDate"
              name="startDate"
              selected={startDate}
              onChange={(startDate) => handleStartDate(startDate)}
              onFocus={() => handleFocus("StartDate")}
              onBlur={handleBlur}
              isClearable
              onChangeRaw={handleStartDateRaw}
              dateFormat="MM/dd/yyyy"
              placeholderText="MM/DD/YYYY"
              autoComplete="off"
              customInput={
                <ReactInputMask mask="99/99/9999" value={startDate} />
              }
            />
            <InputGroupText onClick={() => handleDateClick("startDate")}>
              <img src={Calendar} alt="" />
            </InputGroupText>
          </InputGroup>
        </Col>
        <Col sm={12} md={6}>
          <Label className="mbb-8 add-clinic">
            {" "}
            <span className="text-danger">*</span> Source
          </Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <InputGroup>
                <Field
                  as="select"
                  name="source"
                  id="option"
                  className="order-detail-input"
                  value={labValues.source}
                  onChange={handleChange}
                  // className="form-control"
                >
                  <option value="" label="Select Source" />
                  <option value="option1" label="Pharmacy" />
                  <option value="option2" label="EHR" />
                </Field>
              </InputGroup>
            </FormGroup>
          </Formik>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <Label className="mbb-8 add-clinic">
            <span className="text-danger">*</span> Value
          </Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <InputGroup>
                <Input
                  type="text"
                  placeholder="Enter Value"
                  name="values"
                  value={labValues.values}
                  onChange={handleChange}
                />
              </InputGroup>
            </FormGroup>
          </Formik>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={12} md={12}>
          <Label className="mbb-8 add-clinic">
            {" "}
            <span className="text-danger">*</span> Notes
          </Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <Input
                style={{ border: "1px soild" }}
                className="textlength"
                type="textarea"
                placeholder="Enter Notes "
                value={labValues.notes}
                name="notes"
                onChange={handleChange}
              />
            </FormGroup>
          </Formik>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col sm={12} md={12}>
          <Label className="mbb-8 add-clinic">
            <span className="text-danger">*</span> Description
          </Label>
          <Formik>
            <FormGroup className="controls textarea_info search-flex mb-0">
              <Input
                style={{ border: "1px soild" }}
                className="textlength"
                type="textarea"
                placeholder="Enter Description"
                value={labValues.description}
                name="description"
                onChange={handleChange}
              />
            </FormGroup>
          </Formik>
        </Col>
      </Row>
    </div>
  );
};

export default AddLabvalues;
